export default "__VITE_ASSET__DTbNiOiM__"